<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div
              class="col-md-6"
              style="padding: 70px 0px;"
            >
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('ep_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('ep_desc')}}</p>
            </div>
            <div
              class="col-md-6"
              style="text-align: center;"
            >
              <img
                src="../../assets/imgs/singin_man.png"
                class="pman"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;" >
          <div class="col-md-3">
            <app-e-engineer-sidenav :selectedItem="selectedItem"></app-e-engineer-sidenav>
          </div>
          <div class="col-md-9">

            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('resume_title')}}</span>
            </div>
            <div class="row mt-4">
                <div class="col-md-12 ml-3">
                    <p>{{$t('resume_desc1')}}
                     <br>{{$t('resume_desc2')}}</p>
                </div>
                <div class="col-md-11 mt-4" style="padding-left:30px;">
                  <label for="file-upload" class="btn bluebtn custom-file-upload-pdf">
                     Upload
                  </label>
                  <input ref="myfile" @change="readUrl($event)" id="file-upload" type="file"/>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-11 mt-4" style="padding-left:30px;">
                <v-server-table
                  id="dataTable"
                  ref="pdfTable"
                  class="pfdListing"
                  :columns="columns"
                  :options="options"
                >
                 <template slot="selected" slot-scope="props">
                  <div
                  > {{ props.index }}</div>
                 </template>

                  <template slot="file_name" slot-scope="props">
                    <div
                      class="text-primary cursor"
                    >
                    <a href="javascript:void(0)" @click="downloadFile(props.row.file_path)">
                      <strong>{{ props.row.file_path }}</strong>
                    </a>
                    </div>
                  </template>

                  <template slot="upload_date" slot-scope="props">
                    <div class="text-primary">
                      {{ props.row.time }}
                    </div>
                  </template>

                  <template slot="action" slot-scope="props">
                    <!-- <b-btn variant="danger" @click="confirmAndDelete(props.row)"
                      ><i class="fa fa-trash-o"></i
                    ></b-btn> -->
                    <button class="btn" @click="confirmAndDelete(props.row)"><i class="fa fa-trash"></i></button>
                  </template>

                </v-server-table>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import e_engineer_sidenav from "../engineer/e_engineer_sidenav";
import { EventBus } from "../../main.js";
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      selectedItem: 64,
      loading: false,
      get_favored_mail: true,
      lan: "jp",
      imageBlob: '',

      checkedRows: [],
      options: {
        perPage: 10,
        pagination: {
          chunk: 6,
          edge: false
        },
        cellClasses:{
          file_name: [
            {
                class:'low-balance',
                condition: row => row.file_name
            }
          ]
        },
        columnsClasses:{
          selected:'number',
          file_name: 'file_name',
          upload_date: 'upload_date',
          action: 'action'
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        filterable: false,
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        headings: {
          selected: '#',
          file_name: 'File name',
          upload_date: 'Upload date',
          action: 'Action',

        },
        perPageValues: [],
        requestFunction: this.getResume,
        responseAdapter: ({ data }) => {
          console.log(data,"yo")
          return data
        },
        sortable: ['subcategory_name', 'description', 'subcategory_slug']
      },
         columns: [
        'selected',
        'file_name',
        'upload_date',
        'action',
      ]
    };
  },
  components: {
    appEEngineerSidenav: e_engineer_sidenav
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      if (data.publish_real_name) {
        this.show_real_name = data.publish_real_name;
      }
      if (data.want_to_talk_casually) {
        this.want_to_talk_casually = data.want_to_talk_casually;
      }
      if (data.get_favored_mail == 1 ){
          this.get_favored_mail = true
      }
      else{
          this.get_favored_mail = false
      }
      if (data.get_message_mail == 1) {
          this.get_message_mail = true;
      } else {
          this.get_message_mail = false
      }
  },
  mounted() {
    this.doCenter();
    EventBus.$on("language", data => {
      this.lan = data;
    });
  },
  computed: {
    onResize(event) {
      this.doCenter();
    }
  },
  methods: {
    getResume(data){
      data.token = localStorage.getItem("token");
      data.user_id = JSON.parse(localStorage.getItem("user")).id
      return axios.get("/get-resume",{params: data},{
              headers: { "X-localization": localStorage.getItem("lan") }
            })
           .catch(e => {
              console.log(e)
            })
    },
    downloadFile(path){
      axios({
        url: "/file/resume/"+ path +"?token=" + localStorage.getItem("token"), //your url
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.setAttribute('download', path); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
     confirmAndDelete(record) {
    var vm = this;
     const swalWithBootstrapButtons = Swal.mixin({
          confirmButtonClass: 'btn btn-danger inquiry',
          cancelButtonClass: 'btn trial',
          buttonsStyling: false,
        })

        swalWithBootstrapButtons({
          title: 'Delete',
          text:  'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'cancle',
          reverseButtons: false,
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
             axios
                .post("/delete-resume/"+ record.id +"?token=" + localStorage.getItem("token"), {
                  headers: { "X-localization": localStorage.getItem("lan") }
                })
                .then(res => {
                  this.$toaster.success(vm.$t('delete_message'));
                  this.$refs.pdfTable.refresh()
                })
                .catch(error => console.log(error));
          } else if (
            // Read more about handling dismissals
            result.dismiss === Swal.DismissReason.cancel
          ) {
            // vm.$store.dispatch("logout");
          }
        })
    },
 readUrl(e) {
      const file = e.target.files[0];
      // this.img.push(e.target.files[0].name);
        var reader = new FileReader();
        reader.onload = event => {
          this.engineer_video = ''
          this.cropImg = event.target.result;
          this.uplodPDF();
        }
        reader.readAsDataURL(file);
    
        this.imageBlob = file
        e.target.value = '';
    },
    uplodPDF(){
      var formData = new FormData();
      if (this.imageBlob.type === "image/") {
          formData.append("file", this.imageBlob, 'temp.png');
        }else{
            formData.append("file", this.imageBlob, this.imageBlob.name);
        }
        const vm = this
         axios
          .post(
            "/resume-upload?token=" + localStorage.getItem("token"),
            formData,
            {
              headers: { "X-localization": localStorage.getItem("lan") }
            },

          )
          .then(res => {
            if (!res.data.success) {
              if (res.data[0]) {
                this.$toaster.error(res.data[0]);
                this.$store.dispatch("logout");
              }
              if (res.data.errors) {
                for (var i = 0; i < res.data.errors.length; i++) {
                  this.$toaster.error(res.data.errors[i].message);
                }
              }
            } else {
              this.$toaster.success(vm.$t('success_file_upload'));
              this.$refs.pdfTable.refresh()
            }
          })
          .catch((error) => {
            console.log(error);
          });
        console.log(this.imageBlob)
    },
    doCenter() {
      let txtheight, txtwidth;
      if ($(window).width() <= 975 && $(window).width() >= 751) {
        $("#total").css("font-size", "1rem");
        $("#technical").css("font-size", "1rem");
        $("#management").css("font-size", "1rem");
        $("#business").css("font-size", "1rem");
        txtwidth = [10.44, 20.88, 31.3];
        txtheight = 40;
      } else {
        $("#total").css("font-size", "1.5rem");
        $("#technical").css("font-size", "1.5rem");
        $("#management").css("font-size", "1.5rem");
        $("#business").css("font-size", "1.5rem");
        txtwidth = [15.66, 31.3, 46.95];
        txtheight = 28;
      }
    }
  }
};
</script>

<style  scoped>

.btn {
  background-color: rgb(255, 30, 30);
  border: none;
  border-radius: 100%;
  color: white;
  padding: 0px 5px;
  font-size: 16px;
  cursor: pointer;
}

/* Darker background on mouse-over */
.btn:hover {
  background-color: rgb(177, 26, 26);
}
input[type="file"] {
    display: none;
}
.custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
}

.skillUpdate {
  padding-top: 10px;
  padding-bottom: 20px;
}

.pman {
  width: 120px;
  margin-top: 70px;
}

.slide_options {
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
  padding-left: 15px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 35px;
  max-width: 200px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  height: 50px;
  margin-bottom: 0.1rem;
}
.cline {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.statusnum {
  top: 55%;
  font-weight: bold;
  font-size: 3rem !important;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.custom-wrapper {
  max-height: 250px;
  overflow: auto;
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }
}
</style>
